if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
          this.startLoadingState();

          const content = document.createElement('div');
          const template = this.querySelector('template');
          if (!template) return;

          content.appendChild(template.content.firstElementChild.cloneNode(true));

          this.setAttribute('loaded', true);
          const modelViewer = this.appendChild(content.querySelector('model-viewer'));
          
          if (modelViewer) {
            if (focus) modelViewer.focus();
            
            modelViewer.style.width = '100%';
            modelViewer.style.height = '100%';
            
            modelViewer.setAttribute('ar', '');
            modelViewer.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
            modelViewer.setAttribute('camera-controls', '');
            modelViewer.setAttribute('auto-rotate', '');
            modelViewer.setAttribute('interaction-prompt', 'auto');
            modelViewer.setAttribute('min-camera-orbit', 'auto 15deg auto');
            modelViewer.setAttribute('max-camera-orbit', 'auto 88deg auto');

            this.bindLoadingState(modelViewer);
          }
        }

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }

      startLoadingState() {
        this.classList.remove('is-ready', 'has-loading-error');
        this.classList.add('is-loading');
        this.setLoadingProgress(0);

        window.clearInterval(this.loadingTimer);
        this.loadingTimer = window.setInterval(() => {
          const nextProgress = this.loadingProgress < 45 ? this.loadingProgress + 7 : this.loadingProgress + 3;
          this.setLoadingProgress(Math.min(nextProgress, 88));
        }, 260);
      }

      bindLoadingState(modelViewer) {
        modelViewer.addEventListener('progress', (event) => {
          const totalProgress = event.detail && event.detail.totalProgress;
          if (typeof totalProgress !== 'number') return;

          this.setLoadingProgress(totalProgress * 100);
          if (totalProgress >= 1) this.completeLoadingState();
        });

        modelViewer.addEventListener('load', () => this.completeLoadingState(), { once: true });
        modelViewer.addEventListener('error', () => this.failLoadingState(), { once: true });
      }

      setLoadingProgress(progress) {
        this.loadingProgress = Math.max(0, Math.min(100, Math.round(progress)));

        const progressValue = this.querySelector('[data-product-model-progress-value]');
        const progressBar = this.querySelector('[data-product-model-progress-bar]');

        if (progressValue) progressValue.textContent = `${this.loadingProgress}%`;
        if (progressBar) progressBar.style.width = `${this.loadingProgress}%`;
      }

      completeLoadingState() {
        window.clearInterval(this.loadingTimer);
        this.setLoadingProgress(100);

        window.setTimeout(() => {
          this.classList.remove('is-loading');
          this.classList.add('is-ready');
        }, 320);
      }

      failLoadingState() {
        window.clearInterval(this.loadingTimer);
        this.classList.remove('is-loading');
        this.classList.add('has-loading-error');

        const label = this.querySelector('[data-product-model-progress-label]');
        if (label) label.textContent = 'No se pudo cargar 3D';
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
